<template>
  <div class="container-cidades">
    
    <div class="row">
    <div class="col-sm-12">
      <h1>Gerenciamento de usuários </h1><br>
    </div>

      <input type="hidden" name="id" class="form-control" value="" v-model="id">
          <div class="form-group col-sm-4">
          <label>Nome:</label>
          <input type="text" name="nome" class="form-control" value="" v-model="nome">
        </div>

        <div class="form-group col-sm-4">
          <label>Login:</label>
          <input type="text" name="login" class="form-control" value="" v-model="login">
        </div>

        <div class="form-group col-sm-4">
          <label>senha:</label>
          <input type="password" name="senha" class="form-control" value="" v-model="senha">
        </div>

        <div class="form-group col-sm">
          <label>Permissão:</label>
          <select class="form-control" name="adm" v-model="permissao">
             <option value="4">Corretor</option>
            <option value="2">Corretor Sênior</option>
             <option value="3">Captador</option>
            <option value="1">Administrador</option>
          
          </select>
      </div>

          <button @click="add()" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">SALVAR</button>

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

    </div><!-- row -->


    <div class="row">

 <table class="col-sm table table-striped table-dark">
  <thead>
    <tr>
     
      <th scope="col">Nome</th>
      <th scope="col">Login</th>
      <th scope="col">Deletar</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in usuarios" :key="item.LOG_ID" >
      
      <td>{{item.LOG_NOME}}</td>
       <td>{{item.LOG_LOGIN}}</td>
     
       <td><button type="button" :data-codigo="item.LOG_ID" class="btn btn-info" @click="alterarUsuario({id:item.LOG_ID,login:item.LOG_LOGIN,nome:item.LOG_NOME,senha:item.LOG_SENHA,permissao:item.LOG_PERMISSAO})">Alterar</button></td>
      <td><button type="button" :data-codigo="item.LOG_ID" class="btn btn-danger" @click="deleteUsuario">Deletar</button></td>
    </tr>
   
  </tbody>
</table>

    </div><!-- row table -->



  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Usuario',
  components: {},
 
  data(){
      return {
          usuarios:[],
          nome:'',
          login:'',
          senha:'',
          permissao:2,
          id:'',
          loading: false
      }
  },
 

methods:{
    add(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/novoUsuario',{nome:this.nome,login:this.login,senha:this.senha,permissao:this.permissao,id:this.id})
          .then( () => this.getUsuarios())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;this.nome = '';this.login = '';this.senha = '';this.permissao = 2;this.id = ''})
      },


    getUsuarios(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getUsuarios',{})
          .then(response => this.usuarios = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    deleteUsuario(event){
          let codigo = event.target.dataset.codigo
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/deleteUsuario',{id:codigo})
          .then( () =>  this.getUsuarios())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },

    alterarUsuario(usuario){
       this.nome = usuario.nome;
       this.login = usuario.login;
       this.senha = usuario.senha;
       this.permissao = usuario.permissao;
       this.id = usuario.id;
    }

},
  
  mounted () {
  this.getUsuarios();
  }



}
</script>